import React, { useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";

const EditClinicalSite = () => {
  const [country, setCountry] = useState("Canada");
  const [countryIcon, setCountryIcon] = useState(false);
  const [facility, setFacility] = useState("Hospital");
  const [facilityIcon, setFacilityIcon] = useState(false);

  const countryIconRotate = countryIcon ? "rotate(180deg)" : "rotate(0)";
  const facilityIconRotate = facilityIcon ? "rotate(180deg)" : "rotate(0)";
  const handleCountry = (selected) => {
    setCountry(selected);
  };
  const handleFacility = (selected) => {
    setFacility(selected);
  };
  return (
    <div
      className="modal fade"
      id="editClinicalSite"
      tabindex="-1"
      aria-labelledby="editClinicalSite"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <form action="">
          <div className="modal-content border-0 overlay-rounded">
            <div className="modal-header mt-14 border-0">
              <label className="fs-15" id="editClinicalSite">
                EDIT: Clinical Site
              </label>

              <FaTimes
                size={15}
                className="cursor-pointer text_primary"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="container-fluid p-0">
                <div className="row">
                  <div className="col-md-6 small-text">
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Clinical Site Name:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value="TOH - Riverside Campus"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">City:</label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value="Ontario"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Province:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value="Ottawa"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Country:
                      </label>
                      <div className="col-md-8 d-flex justify-content-end">
                        <div className="dropdown">
                          <div className="dropdown">
                            <button
                              className="btn btn-block border text-left h-35 w-205"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              data-display="static"
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClickCapture={() =>
                                setCountryIcon(!countryIcon)
                              }
                            >
                              <div className="d-flex justify-content-between">
                                <small className="small-text">
                                  {country ? country : "Choose Country"}
                                </small>
                                <BsChevronDown
                                  style={{
                                    transform: countryIconRotate,
                                    transition: "all 0.3s linear",
                                  }}
                                />
                              </div>
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container w-205"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <p className="pl-4 mb-0 pb-2">
                                <small>Choose one country only:</small>
                              </p>

                              <a
                                onClick={() => handleCountry("Canada")}
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>Canada</small>
                              </a>
                              <a
                                onClick={() => handleCountry("United States")}
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>United States</small>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Postal Code:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value="K1H 7W9"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Street Address:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value="1967 Riverside Dr."
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Suite (if applicable):
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 small-text">
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Phone Number:
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value="+1(613)722-7000"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Extension (if applicable):
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="small-text overlay-input"
                          value=""
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">
                        Type of Healthcare Facility:
                      </label>
                      <div className="col-md-8 d-flex justify-content-end">
                        <div className="dropdown">
                          <div className="dropdown">
                            <button
                              className="btn btn-block border text-left h-35 w-205"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              data-display="static"
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClickCapture={() =>
                                setFacilityIcon(!facilityIcon)
                              }
                            >
                              <div className="d-flex justify-content-between">
                                <small className="small-text">
                                  {facility
                                    ? facility
                                    : "Choose type of Facility"}
                                </small>
                                <BsChevronDown
                                  style={{
                                    transform: facilityIconRotate,
                                    transition: "all 0.3s linear",
                                  }}
                                />
                              </div>
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container w-205"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <p className="pl-4 mb-0 pb-2">
                                <small>Choose one:</small>
                              </p>

                              <a
                                onClick={() =>
                                  handleFacility("Ambulatory Healthcare")
                                }
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>Ambulatory Healthcare Services</small>
                              </a>
                              <a
                                onClick={() => handleFacility("Hospital")}
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>Hospital</small>
                              </a>
                              <a
                                onClick={() =>
                                  handleFacility("Nursing & Residential Care")
                                }
                                className="dropdown-item activeHover ml-4 wa"
                                href="#"
                              >
                                <small>
                                  Nursing & Residential Care Facility
                                </small>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">Image:</label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          className="small-text overlay-input"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-md-4 col-form-label">Logo:</label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          className="small-text overlay-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 d-flex justify-content-between">
              <button
                type="button"
                className="btn btn_outline_danger rounded overlay-btn"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-outline-primary rounded overlay-btn"
              >
                Save changes
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditClinicalSite;
